import { formatDate } from 'helpers/utils';
import React from 'react';
import PropTypes from 'prop-types';

const formatDateInfo = (apds, dateType) => (
  apds.map((apd) => (
    apd[dateType] ? (
      <div key={apd.name}><strong>{apd.name}</strong>: {formatDate(apd[dateType], "dd-MMM-yy")}</div>
    ) : null
  ))
);

formatDateInfo.propTypes = {
  apds: PropTypes.object.isRequired,
  dateType: PropTypes.instanceOf(Date).isRequired
}

const PaymentPlanFormatRenderer = (props) => {
  const building = props.data && props.data.building ? props.data.building : {};
  const { payment_term = {} } = building;
  const { plans = [] } = payment_term;

  switch (props.column.colId) {
    case "payment_term.plan_date":
      return formatDateInfo(plans, "plan_date");

    case "payment_term.actual_date":
      return formatDateInfo(plans, "actual_date");

    default:
      return null;
  }
}

PaymentPlanFormatRenderer.propTypes = {
  data: PropTypes.object,
  column: PropTypes.object.isRequired,
  building: PropTypes.object,
  apds: PropTypes.object
}

export default PaymentPlanFormatRenderer;